import { makeAutoObservable } from 'mobx';
import getZipcode from './fn/getZipcode';
import { ZipcodePagination, ZipCodeRange } from '~/definitions/zipcode';
import getPaginationData from './fn/getPaginationData';
import getZipcodeList from './fn/getZipcodeList';
import addZipcode from './fn/addZipcode';
import deleteZipcode from './fn/deleteZipcode';
import checkDuplicatedZipcode from './fn/checkDuplicatedZipcode';
import getExistingZipcode from './fn/getExistingZipcode';
import checkAssignedZipcode from './fn/checkAssignedZipcode';
import assignZipcode from './fn/assignZipcode';
import getZipcodeListAndPagination from './fn/getZipcodListAndPagination';
export default class ZipcodeStore {
    selectedZipcode: string = '';
    isGettingZipcode: boolean = false;
    paginationData: ZipcodePagination[] = [];
    zipcodeList: string[] = [];
    selectedRangeId: string = '';
    isSaveClicked: boolean = false;
    errorKeys: string[] = [];
    addedData: ZipCodeRange = { start: '', end: '' };
    zipCodesToDelete: string[] = [];
    existingZipcodeList: string[] = [];

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.selectedZipcode = '';
        this.isGettingZipcode = false;
        this.paginationData = [];
        this.zipcodeList = [];
        this.selectedRangeId = '';
        this.isSaveClicked = false;
        this.errorKeys = [];
        this.addedData = { start: '', end: '' };
        this.zipCodesToDelete = [];
        this.existingZipcodeList = [];
    }

    setSelectedZipcode = (zipcode: typeof this.selectedZipcode) => {
        this.selectedZipcode = zipcode;
    };

    setIsGettingZipcode(isGetting: typeof this.isGettingZipcode) {
        this.isGettingZipcode = isGetting;
    }

    setPaginationData(data: typeof this.paginationData) {
        this.paginationData = data;
    }

    setZipcodeList(list: typeof this.zipcodeList) {
        this.zipcodeList = list;
    }

    setSelectedRangeId(id: typeof this.selectedRangeId) {
        this.selectedRangeId = id;
    }

    setIsSaveClicked(isClicked: typeof this.isSaveClicked) {
        this.isSaveClicked = isClicked;
    }

    setErrorKeys(keys: typeof this.errorKeys) {
        this.errorKeys = keys;
    }

    setAddedData(data: typeof this.addedData) {
        this.addedData = data;
    }

    setZipCodesToDelete(zipcode: typeof this.zipCodesToDelete) {
        this.zipCodesToDelete = zipcode;
    }

    setExistingZipcodeList(list: typeof this.existingZipcodeList) {
        this.existingZipcodeList = list;
    }

    getZipcode = getZipcode;
    getPaginationData = getPaginationData;
    getZipcodeList = getZipcodeList;
    addZipcode = addZipcode;
    deleteZipcode = deleteZipcode;
    getExistingZipcode = getExistingZipcode;
    checkDuplicatedZipcode = checkDuplicatedZipcode;
    checkAssignedZipcode = checkAssignedZipcode;
    assignZipcode = assignZipcode;
    getZipcodeListAndPagination = getZipcodeListAndPagination;
}
